import { SchedulingModalityEnum } from "@core/enums";
import { quotationIolmParts } from "../quotation/quotation-iolm-parts.model";
import { quotationVOs } from "../quotation/quotationVO.model";
import { IScheduleWorkshop } from "./open.schedulev2.model";

export class ScheduleModel {
  "division": string;
  "scheduleId": number;
  "country": string;
  "contactCountry": string;
  "scheduleSource": string;
  "scheduleType" = 'R';
  "customerId": string | number;
  "contactCustomerId": string | number;
  "scheduleUser"?: string;
  "sendEmail" = true;
  "scheduleDate": string;
  "scheduleHour": number;
  "createS": string;
  "createUser": string;
  "customerRemark": string | null;
  "advisorRemark": string | null;
  "scheduleModality": string = SchedulingModalityEnum.GENERAL_REPAIR;
  "advisor": number;
  "advisorName": string;
  "dealer": number;
  "vin": string;
  "vehiclePlate": string;
  "model": string;
  "group": string | null;
  "towTruckNeeded": string;
  "towTruckType": string | null;
  "towingReason": string | null;
  "returned": string;
  "isDriverInformation": boolean | null;
  "offeredServices": number[];
  "quotationScheduleVO": {
    "quotationVOs": quotationVOs[]
  };
  "iolmParts": quotationIolmParts[];
  "lastKm": number | null;
  "oilLifeRemaining": number | null;
  "iolmMonths": number;
  "campaignsId": number[];
  "referredBy": number;
  "scheduleWorkshop": IScheduleWorkshop[];
  "customerWaiting": boolean;
}
